import { AlertTriangle, CheckCircle2, Info } from "lucide-react";
import type { ReactNode } from "react";

import type { Tone } from "./Badge";
import { cx } from "./cx";

const ALERT_TONES: Record<Exclude<Tone, "neutral">, { box: string; icon: ReactNode }> = {
  success: {
    box: "border-emerald-500/30 bg-emerald-500/10 text-emerald-800 dark:text-emerald-300",
    icon: <CheckCircle2 className="size-4 shrink-0" aria-hidden />,
  },
  warning: {
    box: "border-amber-500/30 bg-amber-500/10 text-amber-800 dark:text-amber-300",
    icon: <AlertTriangle className="size-4 shrink-0" aria-hidden />,
  },
  danger: {
    box: "border-red-500/30 bg-red-500/10 text-red-800 dark:text-red-300",
    icon: <AlertTriangle className="size-4 shrink-0" aria-hidden />,
  },
  info: {
    box: "border-sky-500/30 bg-sky-500/10 text-sky-800 dark:text-sky-300",
    icon: <Info className="size-4 shrink-0" aria-hidden />,
  },
};

export function Alert({ tone = "info", children }: { tone?: Exclude<Tone, "neutral">; children: ReactNode }) {
  const t = ALERT_TONES[tone];
  return (
    <div
      role={tone === "danger" ? "alert" : "status"}
      className={cx("flex gap-2 rounded-lg border px-3 py-2.5 text-sm", t.box)}
    >
      <span className="mt-0.5">{t.icon}</span>
      <div className="min-w-0">{children}</div>
    </div>
  );
}
